import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import {
    Background,
    ButtonGroup,
    CancelButton,
    ConfirmButton,
    Message,
    PopupContainer,
} from "./styles";

interface Props {
    show?: boolean;
    handleConfirm(): void;
    handleCancel(): void;
    phrase: string;
}

export type PopupHandles = {
    open: () => void;
    close: () => void;
};

const Popup = forwardRef<PopupHandles, Props>(
    ({ show, handleConfirm, handleCancel, phrase }, ref) => {
        const [isOpen, setIsOpen] = useState(false);

        useEffect(() => {
            if (typeof show === "boolean") setIsOpen(show);
        }, [show]);

        useImperativeHandle(ref, () => ({
            open: () => setIsOpen(true),
            close: () => setIsOpen(false),
        }));

        return (
            <Background show={isOpen}>
                <PopupContainer>
                    <Message>{phrase}</Message>
                    <ButtonGroup>
                        <CancelButton onClick={handleCancel}>NÃO</CancelButton>
                        <ConfirmButton onClick={handleConfirm}>
                            SIM
                        </ConfirmButton>
                    </ButtonGroup>
                </PopupContainer>
            </Background>
        );
    }
);

Popup.displayName = "Popup";

export { Popup };
